import React from "react";
import Modal from "../Modal";

export default function ConfirmModal({
  open,
  title = "Confirm",
  message,
  confirmLabel = "Delete",
  danger = true,
  onConfirm,
  onClose,
}) {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      footer={
        <>
          <button className="ide-button" onClick={onClose}>Cancel</button>
          <button
            className={danger ? "ide-button-danger" : "ide-button-primary"}
            onClick={async () => {
              try { await onConfirm?.(); onClose?.(); } catch (_) { /* surface via toast */ }
            }}
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      <div className="text-sm text-ide-text leading-relaxed">{message}</div>
    </Modal>
  );
}
